import React from 'react';
import { classList } from '../../../../../utils/string.ts';

export type AdProps = {
  adId: string;
  highlighted?: boolean;
  disclaimer?: boolean;
  minHeightClass?: string;
  className?: string;
  dataRef?: string;
};

export const Ad: React.FunctionComponent<AdProps> = props => {
  const { highlighted = false, disclaimer = true, minHeightClass = 'min-h-20' } = props;

  return (
    <div
      className={classList(
        highlighted ? 'bg-sk-grey-100 outline-sk-grey-500 outline' : 'bg-sk-grey-200',
        'flex w-full flex-col items-center justify-center py-4',
        props.className
      )}
      data-ref={props.dataRef}
    >
      {disclaimer && <div className="text-sk-dark-blue mb-2 text-xs">Anzeige</div>}
      <div
        id={props.adId}
        className={classList(minHeightClass, 'h5v-content h5v-placeholder')}
      ></div>
    </div>
  );
};
